export default "__VITE_ASSET__CLuyImwM__"